import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#arrowLeft'
const _hoisted_2 = _imports_0 + '#searchBtn'
const _hoisted_3 = { class: "catalog-item" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "catalog-item__container" }
const _hoisted_6 = { class: "catalog-item__header" }
const _hoisted_7 = { class: "catalog-item__header-left" }
const _hoisted_8 = { class: "catalog-item__list" }
const _hoisted_9 = {
  key: 0,
  class: "loader"
}

import CartModal from "@/components/CartModal.vue";
  import { ISection, ISectionsItem } from "@/models/models";
  import { ref } from "vue";
  import { useRouter } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogMenuName',
  setup(__props) {

  const router = useRouter();

  const sections = ref<Array<ISectionsItem>>([] as Array<ISectionsItem>);
    
  const secton = ref<ISection>({} as ISection);

  const isLoading = ref(true);

  fetch(`https://akshop.a-dev.xyz/api/v1/sections/${router.currentRoute.value.params.name}`)
    .then((response) => response.json())
    .then((data) => {
      sections.value = data.sections;
      secton.value = data.section;
      isLoading.value = false;
    });

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
                class: "catalog-item__back"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  width: "8",
                  height: "12"
                }, [
                  _createElementVNode("use", { "xlink:href": _hoisted_1 })
                ], -1)
              ])),
              _createElementVNode("h1", null, _toDisplayString(secton.value.name), 1)
            ]),
            _createVNode(_component_RouterLink, { to: "/search" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  width: "36",
                  height: "36"
                }, [
                  _createElementVNode("use", { "xlink:href": _hoisted_2 })
                ], -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "loader-spinner" }, null, -1)
                ])))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(sections.value, (item) => {
                  return (_openBlock(), _createBlock(_component_RouterLink, {
                    class: "catalog-item__link",
                    to: `/catalog/${item.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 256))
          ])
        ])
      ])
    ]),
    _createVNode(CartModal)
  ], 64))
}
}

})